<mat-form-field appearance="fill" *ngIf="showDatePicker && !hasFilter">
  <mat-label>Select a date</mat-label>
  <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="onDateChange($event)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

<mat-form-field appearance="fill" *ngIf="showDatePicker && hasFilter">
  <mat-label>Select a date</mat-label>
  <input matInput [matDatepickerFilter]="dateFilter" [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="onDateChange($event)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
